export const defaultFields = [
    'Номер заявки',
    'Тема',
    'Дата подачи',
    'Статус',
    'Статус согласования',
    'Ожидаемая дата исполнения'
];
export const allFields = [
    'Номер заявки',
    'Тема',
    'Дата подачи',
    'Статус',
    'Ожидаемая дата исполнения',
    'Дата закрытия',
    'Срок в работе',
    'Страхователь',
    'Статус согласования'
];
export const fieldMappings: Record<string, string> = {
    'Номер заявки': 'Number',
    'Тема': 'ThemeName',
    'Дата подачи': 'Date',
    'Статус': 'StatusName',
    'Ожидаемая дата исполнения': 'AuthorsExpectedCompletionDate',
    'Дата закрытия': 'CompletionDate',
    'Срок в работе': 'DaysInWork',
    'Страхователь': 'InsurerName',
    'Статус согласования': 'AgreementResultName'
};